import { render, staticRenderFns } from "./ProfileActionCall.vue?vue&type=template&id=f53ac79a&"
import script from "./ProfileActionCall.vue?vue&type=script&lang=js&"
export * from "./ProfileActionCall.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports